import React from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'

import {
  required,
  validateEmailArray,
  composeValidators,
} from '../../utils/validation'
import TextInput from '../../components/TextInput/index'
import Modal from '../Modal'
import Button from '../../components/Button'

export const SendMailModal = ({ onClose, isOpen, onSubmit }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    closer={true}
    title="Wyślij materiały"
  >
    <P>
      Wprowadź po przecinku wiecej niż 1 adres email aby wysłać do wielu osób
      jednocześnie.
    </P>
    <Form onSubmit={onSubmit}>
      {({ handleSubmit }) => (
        <>
          <Field
            component={TextInput}
            label="Email"
            name="recipients"
            placeholder="adres1@domena.pl, adres2@domena.pl ..."
            validate={composeValidators(required, validateEmailArray)}
          />
          <Footer>
            <Button label="Anuluj" width="45%" color="grey" onClick={onClose} />
            <Button
              label="Wyślij"
              type="submit"
              onClick={handleSubmit}
              width="45%"
            />
          </Footer>
        </>
      )}
    </Form>
  </Modal>
)

const P = styled.p`
  line-height: 1.3rem;
  margin-bottom: 2rem;
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;

  &::before {
    position: absolute;
    left: 0;
    bottom: 6.5rem;
    content: '';
    border-bottom: 1px solid #eee;
    width: 100%;
  }
`

export default SendMailModal
